/*
 * nav.js
 * Nav  Javascript
 * @Company: Strange Animals
 * ----------------------------------
 */

$(function() {
    //Remove slide-class (a hover animation) from active nav items.
    var $navItems = $('.main-page .navbar-nav li');

    $navItems.each(function(index) {
        if ($(this).hasClass('current') || $(this).hasClass('section')) {
            $(this).removeClass('slide-hover');
        }
    });
});
